import { map } from 'lodash'

export type TNotificationTrigger =
  | 'created'
  | 'createdOnce'
  | 'cancelled'
  | 'pickup'
  | 'pickupIssue'
  | 'pickupAvis'
  | 'pickupAvisOnce'
  | 'pickupDelayed'
  | 'loadedForDelivery'
  | 'loadingIssue'
  | 'delivery'
  | 'deliveryIssue'
  | 'deliveryAvis'
  | 'deliveryAvisOnce'
  | 'deliveryDelayed'
  | 'orderCreationPickupDay'

export function getNotificationTriggerLabels(): Record<
  TNotificationTrigger,
  string
> {
  return {
    created: i18n.t('order_creation', 'Auftragserstellung'),
    createdOnce: i18n.t(
      'order_creation_once',
      'Auftragserstellung (Einmal pro Tag)',
    ),
    orderCreationPickupDay: i18n.t(
      'order_creation_pickup_day',
      'Auftragserstellung (am Abholtag)',
    ),
    cancelled: i18n.t('notification_trigger_cancelled', 'Wenn storniert'),
    pickup: i18n.t('pickup', 'Abholung'),
    pickupIssue: i18n.t('pickup_issue', 'Probleme bei Abholung'),
    pickupAvis: i18n.t('pickup_avis', 'Abholung (Avisierung)'),
    pickupAvisOnce: i18n.t(
      'pickup_avis_once',
      'Abholung (Avisierung - Einmal pro Tag)',
    ),
    pickupDelayed: i18n.t('pickup_delayed', 'Abholung (verspätet)'),
    loadedForDelivery: i18n.t(
      'loaded_for_delivery',
      'Sendung zur Auslieferung verladen',
    ),
    loadingIssue: i18n.t('loading_issue', 'Beladefehler (Sendung fehlt etc.)'),
    delivery: i18n.t('delivery', 'Zustellung'),
    deliveryIssue: i18n.t('delivery_issue', 'Probleme bei Zustellung'),
    deliveryAvis: i18n.t('delivery_avis', 'Zustellung (Avisierung)'),
    deliveryAvisOnce: i18n.t(
      'delivery_avis_once',
      'Zustellung (Avisierung - Einmal pro Tag)',
    ),
    deliveryDelayed: i18n.t('delivery_delayed', 'Zustellung (verspätet)'),
  }
}

export function notificationTriggerOptions(): {
  label: string
  value: string
}[] {
  const labels = getNotificationTriggerLabels()
  return map(labels, (label, value) => ({
    label,
    value,
  }))
}
